document.addEventListener('DOMContentLoaded', function () {
  const playButton = document.getElementById('play-video');

  if (playButton) {
    playButton.addEventListener('click', function (ev) {
      ev.preventDefault();

      // Hide the placeholder image
      const placeholder = document.querySelector('.video-placeholder-img');
      if (placeholder) {
        placeholder.style.display = 'none';
      }

      // Find the first visible video
      const videos = document.querySelectorAll('.html-video');
      let visibleVideo = null;
      videos.forEach(video => {
        const style = window.getComputedStyle(video);
        if (style.display !== 'none' && style.visibility !== 'hidden') {
          visibleVideo = video;
        }
      });

      if (visibleVideo && visibleVideo.tagName.toLowerCase() === 'video') {
        visibleVideo.play();
      } else {
        const videoElement = document.getElementById('video');
        if (videoElement) {
          let videoUrl = videoElement.getAttribute('data-src');
          videoUrl += '&autoplay=1';
          videoElement.setAttribute('src', videoUrl);
        }
      }
    });
  }
});